import { useQuery } from '@tanstack/react-query'
import { getUserById } from '@/services/users/users'

export const useGetUserById = (userId: string | null) => {
  return useQuery({
    queryKey: ['users', userId],
    queryFn: () => getUserById(userId!),
    enabled: !!userId, // Only run query if userId exists
    staleTime: 30000, // Consider data fresh for 30 seconds
    retry: false, // Don't retry on failure
  })
}
